'use client';
import Carousel_time_turn, { DaysGrid } from '../Carousel_time_turn';
import GridTimeTurn, { TypeTimeTurn } from '../GridTimeTurn';
import { TypeAllTurns, TypeContent_rotaing } from '../types/AdmissionType';
import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import {
    setSelectedTurn,
    setUpdateTurnsToFirst,
} from '@/lib/RTK/features/AdmissionSlice';
import { BtnAnimateBorder } from '@/components/utils/btn-animate-border';
import { CiCalendarDate } from 'react-icons/ci';

export default function Content_Roting(props: TypeContent_rotaing) {
    const dispatch = useAppDispatch();
    const {
        allTurns,
        dates,
        doctor,
        setSubmitEnable,
        matab_plus_id,
        timeTurnfirst,
        setStep,
        resetContent,
        setResetContent,
        firstDateTimes,
    } = props;

    const daysRef = useRef<DaysGrid>(null);
    const updateTurnsToFirst = useAppSelector(
        (state) => state.admission.updateTurnsToFirst,
    );
    const [currentTimeTurn, setCurrentTimeTurn] = useState<
        number | null | 'first'
    >(null);
    const [currentDates, setCurrentDates] = useState(
        allTurns ?? ([] as TypeAllTurns[]),
    );
    const [currentTimeDay, setCurrentTimeDay] = useState(0);
    const [dateTimes, setDateTimes] = useState(
        firstDateTimes ?? ([] as TypeTimeTurn[]),
    );

    useEffect(() => {
        setSubmitEnable(currentTimeTurn !== null);
        if (currentTimeTurn !== null && currentTimeTurn !== 'first') {
            dispatch(
                setSelectedTurn({
                    date: allTurns[currentTimeDay].date_g,
                    jalali: allTurns[currentTimeDay].date_j,
                    time: dateTimes[currentTimeTurn].time,
                    childId: 0,
                }),
            );
            if (setStep) {
                setStep(2);
            }
        }
    }, [
        allTurns,
        currentTimeDay,
        currentTimeTurn,
        dateTimes,
        dispatch,
        setStep,
        setSubmitEnable,
    ]);

    useEffect(() => {
        if (updateTurnsToFirst && dateTimes.length > 0) {
            setCurrentTimeDay(0);
            setCurrentTimeTurn(0);
            daysRef.current?.setSelectedDay(0, 0);
            setSelectedTurn({
                date: timeTurnfirst?.first_date || '',
                time: timeTurnfirst?.first_time || '',
                childId: '0',
            });

            dispatch(setUpdateTurnsToFirst(false));
        }
    }, [
        updateTurnsToFirst,
        dateTimes,
        timeTurnfirst?.first_date,
        timeTurnfirst?.first_time,
        dispatch,
    ]);

    useEffect(() => {
        setCurrentDates(allTurns);
        setCurrentTimeDay(currentTimeDay);
        setCurrentTimeTurn(null);
        if (resetContent) {
            setCurrentDates(allTurns);
            setCurrentTimeTurn(null);
            setResetContent?.(false);
        }
    }, [allTurns, currentTimeDay, dates, resetContent, setResetContent]);

    function handleSetTimes(index: number, data: TypeTimeTurn[]) {
        setCurrentTimeDay(index);
        setDateTimes(data);
    }

    return (
        <div className="w-full">
            <div className="mx-auto">
                {currentDates.length > 0 && (
                    <>
                        <div className="flex justify-between items-center">
                            <p className="text-base font-semibold">
                                انتخاب روز
                            </p>

                            <div
                                onClick={() => {
                                    const day = currentDates.findIndex(
                                        (d) => Number(d.count) > 0,
                                    );

                                    setCurrentTimeDay(day >= 0 ? day : 0);
                                    setCurrentTimeTurn(null);
                                    daysRef.current?.setSelectedDay(
                                        day >= 0 ? day : 0,
                                        'first',
                                    );
                                    setSelectedTurn({
                                        date: timeTurnfirst?.first_date || '',
                                        time: timeTurnfirst?.first_time || '',
                                        childId: '0',
                                    });
                                }}
                                className="relative flex flex-col cursor-pointer hover:opacity-70 transition-opacity items-center justify-center overflow-hidden rounded-lg border"
                            >
                                <div className="text-black flex gap-2 px-2 py-2 text-center text-sm font-semibold ">
                                    انتخاب اولین نوبت آزاد
                                    <CiCalendarDate className="text-xl" />
                                </div>
                                <BtnAnimateBorder
                                    size={58}
                                    duration={12}
                                    colorFrom="#3C3599"
                                    colorTo="#3C3599"
                                    delay={9}
                                    borderWidth={1}
                                />
                            </div>
                        </div>
                        <Carousel_time_turn
                            daysRef={daysRef}
                            setSelectedTurn={setCurrentTimeTurn}
                            doctor={doctor}
                            handleSetTimes={handleSetTimes}
                            currentDateTimes={dateTimes}
                            currentDates={allTurns}
                            // dates={dates}
                            firstDateTimes={firstDateTimes}
                            matab_plus_id={matab_plus_id}
                        />
                    </>
                )}
            </div>
            <hr className="border-dashed border-2 border-gray-200" />
            <div className="w-full">
                <GridTimeTurn
                    currentTimeTurn={
                        currentTimeTurn === 'first' ? null : currentTimeTurn
                    }
                    setCurrentTimeTurn={(value) => {
                        setCurrentTimeTurn(value);
                    }}
                    dateTimes={dateTimes}
                />
            </div>
        </div>
    );
}
